export default __webpack_public_path__ + "static/post_1-45d23480ef37e94729a21503fb95c923.png";